import { View } from '@react-pdf/renderer';

export const Box = View;
